/*
 * Breadcrumbs component — renders the trail derived by
 * navigation/breadcrumbs.ts. Stateless: caller passes the trees +
 * console label (so the same component works for both consoles).
 */

import { Link, useLocation } from "react-router-dom";
import { deriveBreadcrumbs, type BreadcrumbContext } from "../navigation/breadcrumbs.js";

export interface BreadcrumbsProps {
  ctx: BreadcrumbContext;
  /** Hide the root crumb (useful when the page-head already shows the console). */
  hideRoot?: boolean;
}

export default function Breadcrumbs({ ctx, hideRoot }: BreadcrumbsProps) {
  const location = useLocation();
  const trail = deriveBreadcrumbs(location.pathname, ctx);
  const visible = hideRoot ? trail.slice(1) : trail;
  if (visible.length <= 1) return null;
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {visible.map((crumb, i) => {
          const isLast = i === visible.length - 1;
          return (
            <li key={`${crumb.label}-${i}`} className={isLast ? "breadcrumb-leaf" : undefined}>
              {crumb.to && !isLast ? (
                <Link to={crumb.to}>{crumb.label}</Link>
              ) : (
                <span aria-current={isLast ? "page" : undefined}>{crumb.label}</span>
              )}
              {!isLast && <span className="breadcrumb-sep" aria-hidden> / </span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
